import Image from "next/image";
import React from "react";
import { EventBySlugQuery } from "@src/@types/api.d";
import Icon from "@src/components/Icon";
import quotesFlowerBorder from "../../../../public/images/t7-quote-flower.png";

interface IFooter {
  slug: EventBySlugQuery | undefined;
}

const Footer = ({ slug }: IFooter) => {
  return (
    <footer className="w-full min-h-[22rem] lg:min-h-[25rem] overflow-hidden bg-white flex flex-col">
      <div className="h-[12rem] lg:h-[15rem] flex flex-col gap-2 justify-center items-center relative px-8 overflow-hidden border-t-4 border-t-black mx-4">
        <Icon iconName="ring" />

        <p className="font-oceanTrace text-sm md:text-[1.5rem] leading-[100%] mt-[2rem] font-normal text-black">
          MADE WITH{" "}
          <a
            href="https://www.inawo.com"
            target="_blank"
            rel="noopener noreferrer"
            className="border-b-[0.5px] border-black pb-[0.5px]"
          >
            INAWO
          </a>
        </p>

        <p className="font-inter font-light text-[1rem] md:text-[1.5rem] leading-[100%] mt-[1.5rem] md:mt-[2rem] w-full text-black text-center">
          The number one website maker for the culturally relevant
        </p>
      </div>

      <div className="relative flex h-[10rem] md:h-[15rem] items-center justify-center overflow-hidden border-b border-b-[#8C7756] bg-white px-8">
        {/* Bottom Left Flower */}
        <div className="absolute bottom-[-120px] left-[-120px] z-0 rotate-[270deg] scale-50 md:scale-100 lg:bottom-[-80px] lg:left-[-80px]">
          <Image
            src={quotesFlowerBorder}
            alt="decorative flower"
            width={300}
            height={300}
            className="object-contain"
          />
        </div>

        {/* Bottom Right Flower */}
        <div className="absolute bottom-[-120px] right-[-120px] z-0 scale-50 md:scale-100 lg:bottom-[-80px] lg:right-[-80px]">
          <Image
            src={quotesFlowerBorder}
            alt="decorative flower"
            width={300}
            height={300}
            className="object-contain"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
